import { Form } from "react-bootstrap";
import { etiquetaJornada } from "./jornadasBac";

// Filtro "Jornada" para Visitas, Barrido PAI, MRCV y Mapa.
// value = "" (todas) | código de la jornada | "__sin__" (sin jornada)
export default function SelectorJornada({ jornadas = [], value, onChange, style }) {
  if (!onChange) return null; // la jornada ya está elegida al ingresar
  return (
    <Form.Select value={value} onChange={(e) => onChange(e.target.value)} style={{ maxWidth: 300, fontSize: 13, ...style }} title="Filtrar por jornada BAC">
      <option value="">📅 Todas las jornadas</option>
      {jornadas.map((j) => <option key={j.codigo} value={j.codigo}>{etiquetaJornada(j)}</option>)}
      <option value="__sin__">Sin jornada</option>
    </Form.Select>
  );
}

// ¿El registro pertenece a la jornada elegida?
// (sin distinguir mayúsculas ni espacios al final, igual que la base de datos)
const norm = (c) => String(c || "").trim().toLowerCase();
export const coincideJornada = (codigoRegistro, filtro) =>
  !filtro || (filtro === "__sin__" ? !codigoRegistro : norm(codigoRegistro) === norm(filtro));
